import * as React from 'react';

import { getDisplayDateAndTime } from 'utils/date';

import './outfit-decline-history.scss';

import { RealmOutfitDeclinedReason } from 'modules/realm-outfits/types/RealmOutfit.type';

type Props = {
  declineHistories: Array<RealmOutfitDeclinedReason>
};

const OutfitDeclineHistory = ({ declineHistories }: Props) => {
  const renderReason = (reason: RealmOutfitDeclinedReason, index: number) => (
    <div
      key={`decline-history-${index}`}
      className="outfit-decline-history__reason"
    >
      {reason.text}
      <div className="outfit-decline-history__meta">
        {getDisplayDateAndTime(reason.date)}
      </div>
    </div>
  );

  return (
    <React.Fragment>
      {
        declineHistories.map(renderReason)
      }
    </React.Fragment>
  );
};

export default OutfitDeclineHistory;
